import Vue from 'vue';
import app from './app.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import '@fontsource/inter';
import VueTelInputVuetify from 'vue-tel-input-vuetify/lib';
import VueYandexMetrika from 'vue-yandex-metrika';   

Vue.config.productionTip = false;

Vue.use(VueTelInputVuetify, {
  vuetify
});

// Инициализация счётчика Top.Mail.Ru
(function (d, w, id) {
  if (d.getElementById(id)) 
    return;
  var ts = d.createElement('script');
  ts.type = 'text/javascript';
  ts.async = true;
  ts.id = id;
  ts.src = 'https://top-fwz1.mail.ru/js/code.js';
  var f = function () {
    var s = d.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ts, s);
  };
  if (w.opera === '[object Opera]') {
    d.addEventListener('DOMContentLoaded', f, false);
  } 
  else {
    f();
  }
})(document, window, 'tmr-code');

// Отправка события pageView
window._tmr = window._tmr || [];
window._tmr.push({ id: '3581326', type: 'pageView', start: new Date().getTime() });
window._tmr.push({ id: '3581326', type: 'reachGoal', goal: 'mt_login', userid: 'UserID' });

// Тестоый счётчик
if (process.env.NODE_ENV !== 'production') {
  Vue.use(VueYandexMetrika, {
    id: 89201011,
    router: router,
    env: process.env.NODE_ENV// 'production'
    // other options
  });
}
// Боевой
else {
  Vue.use(VueYandexMetrika, {
    id: 89201607,
    router: router,
    env: process.env.NODE_ENV
    // other options
  });
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(app)
}).$mount('#app');
